import angular from 'angular';

import template from './signup.html';
import './signup.styl';

function signupComponent($state, $mdDialog, $translate, $tszToast, AuthService) {

  'ngInject';

  this.loading = false;
  this.error = '';

  this.data = {
    email: '',
    password: '',
    confirmPassword: '',
    companyName: '',
  };

  this.signup = (form) => {

    if (form.$valid) {

      this.loading = true;

      AuthService.signup(this.data.email, this.data.password, this.data.companyName)
      .then((response) => {
        if (response.status === 200) {
          // signup succeeded
          const toastOpts = {
            hideDelay: 300000,
          };
          $tszToast.showSuccess('Registro realizado. Le hemos enviado un correo electrónico para validar su cuenta.', toastOpts);
          console.log('Successful signup!');
        } else {
          console.log(response);
          if (response.data && response.data.code) {
            $translate(`ERROR.${response.data.code}`)
            .then((errorMsg) => {
              $tszToast.showError(errorMsg);
              this.error = errorMsg;
            });
          }
        }
      }).catch((err) => {
        // signup error
        if (err.data && err.data.code) {
          $translate(`ERROR.${err.data.code}`)
          .then((errorMsg) => {
            $tszToast.showError(errorMsg);
            this.error = errorMsg;
          });
        }
      }).finally(() => {
        // regardless of the response, change the loading state
        this.loading = false;
      });
    }
  };

  this.showCookiesDialog = (ev) => {
    ev.stopPropagation();
    this.showDialog(ev, 'cookies');
  };

  this.showLegalNoticeDialog = (ev) => {
    ev.stopPropagation();
    this.showDialog(ev, 'legal_notice');
  };

  this.showPrivacyPolicyDialog = (ev) => {
    ev.stopPropagation();
    this.showDialog(ev, 'privacy_policy');
  };

  this.showUsageTermsDialog = (ev) => {
    ev.stopPropagation();
    this.showDialog(ev, 'usage_terms');
  };

  this.showDialog = (ev, modal) => {
    $mdDialog.show({
      controller: ($scope) => {
        $scope.close = () => {
          $mdDialog.hide();
        };
      },
      controllerAs: 'ctrl',
      templateUrl: `/static/modals/${modal}.html`,
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true,
      fullscreen: false, // Only for -xs, -sm breakpoints.
    });
  };

}

export default {
  template,
  controller: signupComponent,
};



// WEBPACK FOOTER //
// ./src/containers/signup/index.js